import styled from 'styled-components'
import { NumberInput as NumberInputComponent } from 'ui'
import AspectRatioComponent from './aspect-ratio'
import ResizeComponent from './resize'

export const AspectRatio = styled(AspectRatioComponent)`
    grid-column: span 8;
`

export const Ext = styled.span`
    margin-left: 0.25em;
    opacity: 0.7;
`

export const NumberInput = styled(NumberInputComponent)`
    margin-right: 10px;
    width: 70px;

    &:last-of-type {
        margin-right: 0;
    }
`

export const RatioLock = styled.i`
    display: inline-block;
    font-size: 15px;
    margin-left: 5px;
    margin-top: -1px;
    transform: rotate(-45deg);
    vertical-align: middle;
`

export const Resize = styled(ResizeComponent)`
    grid-column: span 4;
`
